import { useState } from "react";
import {
  IoCheckmark,
  IoCopyOutline,
  IoLockClosedOutline,
  IoLockOpenOutline,
} from "react-icons/io5";
import { useAxios } from "../../../hooks/axios";
import api from "../../../hooks/api";
import classNames from "./ShareRecording.module.css";
import Button from "../../common/Button";
import { IoMdAdd } from "react-icons/io";
import RadixDialog from "../../common/dialogs/RadixDialog";
import Select, { SelectItem } from "../../common/Select";

type Props = {
  recordingId: string;
  isPublic: boolean;
};

const ShareRecording = ({ recordingId, isPublic }: Props) => {
  const [isShared, setIsShared] = useState(isPublic);
  const [showCopied, setShowCopied] = useState(false);
  const axios = useAxios();
  const changeVisbility = api.useUpdateRecordingVisibility(axios);
  const shareableLink = `${window.location.origin}/recording/${recordingId}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareableLink);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
    handleVisibilityChange(true);
  };

  const handleVisibilityChange = async (newVisibility: SelectItem["value"]) => {
    if (typeof newVisibility !== "boolean") return;
    if (newVisibility === isShared) return;
    setIsShared(newVisibility); //Optimistic updates
    await changeVisbility({
      recording_id: recordingId,
      public: newVisibility,
    });
  };

  return (
    <RadixDialog
      title="Share recording"
      trigger={
        <Button>
          <IoMdAdd />
          Share
        </Button>
      }
      content={
        <div className={classNames.ShareRecording}>
          <Select
            selected={isShared}
            onChange={handleVisibilityChange}
            triggerClassName={classNames.Trigger}
            contentClassName={classNames.Content}
            items={[
              {
                value: false,
                label: (
                  <>
                    <IoLockClosedOutline />
                    Only host or participants can view
                  </>
                ),
              },
              {
                value: true,
                label: (
                  <>
                    <IoLockOpenOutline />
                    Anyone with link can view
                  </>
                ),
              },
            ]}
          />
          <Button onClick={handleCopy} color="gray" backgroundColor="black">
            {showCopied ? (
              <>
                <IoCheckmark />
                Copied!
              </>
            ) : (
              <>
                <IoCopyOutline />
                Copy link
              </>
            )}
          </Button>
        </div>
      }
    />
  );
};

export default ShareRecording;
